module.exports = __webpack_public_path__ + "img/my_bubble_hint@2x.495f12a1.png";